export default __webpack_public_path__ + "static/3-a09b2f9839988f9a275ef8ca50b3a9c8.jpg";